// Socket.IO client voor real-time in-app notifications (PRD-01 §9.8).
//
// - Lazy singleton: socket wordt pas opgezet bij eerste `getSocket()`.
// - Auto-reconnect via socket.io-client defaults.
// - JWT-token wordt uit `authStore` gelezen; bij token-refresh updaten we
//   `auth.token` op de socket en triggeren reconnect.

import { io, type Socket } from "socket.io-client";
import { authStore } from "./auth";

let _socket: Socket | null = null;

export function getSocket(): Socket {
  if (_socket) return _socket;

  _socket = io({
    path: "/socket.io",
    autoConnect: true,
    reconnection: true,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
    auth: (cb) => cb({ token: authStore.getAccessToken() ?? "" }),
    transports: ["websocket", "polling"],
  });

  // Bij auth-fail: server disconnect ons. We laten de huidige access-token
  // refresh-pad (via api.ts) zijn werk doen; de socket reconnect dan vanzelf.
  _socket.on("connect_error", (err) => {
    console.warn("[socket] connect_error", err.message);
  });

  return _socket;
}

export function disconnectSocket(): void {
  if (_socket) {
    _socket.disconnect();
    _socket = null;
  }
}
